/* eslint-disable key-spacing */
import { Icon } from '@fpxfd/next';
import $i18n from 'panda-i18n';
import { Children } from 'react';

const headerMenuConfig = [];

interface MenuConfigItem {
  name: string;
  path?: string;
  icon?: string;
  children?: MenuConfigItem[];
}

interface MenuConfig {
  index?: MenuConfigItem[];
  inbound?: MenuConfigItem[];
  outbound?: MenuConfigItem[];
  basedata?: MenuConfigItem[];
  inside?: MenuConfigItem[];
  billboard?: MenuConfigItem[];
  automation?: MenuConfigItem[];
  returnService?: MenuConfigItem[];
  goods?: MenuConfigItem[];
  order?: MenuConfigItem[];
  service?: MenuConfigItem[];
  allocate?: MenuConfigItem[];
  fba?: MenuConfigItem[];
  dev?: MenuConfigItem[];
}

// 入库
const inboundConifg: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'Appointment.four_px', dm: '预约' }),
    icon: 'wms-yuyuejihua',
    children: [
      {
        name: $i18n.get({ id: 'ReservationPanel.four_px', dm: '预约面板' }),
        path: '/inbound/ReceivingPlan/list',
      },

      {
        name: $i18n.get({ id: 'YYGL.AppointmentManagement.four_px', dm: '预约管理' }),
        path: '/inbound/ReceivingPlan/booking',
      },

      {
        name: $i18n.get({ id: 'CabinetManagement.four_px', dm: '提柜管理' }),
        path: '/inbound/ReceivingPlan/unfindlist',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
    icon: 'wms-xiehuo',
    children: [
      {
        name: $i18n.get({ id: 'UnloadingWorkOrder.four_px', dm: '卸货作业单' }),
        path: '/inbound/DischargeTask/list',
      },

      {
        name: $i18n.get({ id: 'UnloadingOperationDetails.four_px', dm: '卸货作业明细' }),
        path: '/inbound/DischargeTask/dischargeAll',
      },

      {
        name: $i18n.get({ id: 'XHZYBZ.UnloadingProcedure.four_px', dm: '卸货作业步骤' }),
        path: '/inbound/DischargeTask/dischargeStep',
      },

      {
        name: $i18n.get({ id: 'AbnormalDischargeReport.four_px', dm: '卸货异常报表' }),
        path: '/inbound/DischargeTask/dischargeChart',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    icon: 'wms-shouhuo',
    children: [
      {
        name: $i18n.get({ id: 'WorkOrder.four_px', dm: '收货作业单' }),
        path: '/inbound/receipt/list',
      },

      {
        name: $i18n.get({ id: 'DeliveryDetails.four_px', dm: '收货作业明细' }),
        path: '/inbound/receipt/detailList',
      },

      {
        name: $i18n.get({ id: 'ReceiptOperationSteps.four_px', dm: '收货操作步骤' }),
        path: '/inbound/receipt/stepList',
      },

      {
        name: $i18n.get({ id: 'ReceiptExceptionReport.four_px', dm: '收货异常报表' }),
        path: '/inbound/receipt/abnormalList',
      },

      {
        name: $i18n.get({ id: 'InboundExceptionReport.four_px', dm: '入库异常报表' }),
        path: '/inbound/receipt/goodsAbnor',
      },

      {
        name: $i18n.get({ id: 'BatchDetailReport.four_px', dm: '批次明细报表' }),
        path: '/inbound/puton/batchmanage',
      },

      {
        name: $i18n.get({ id: 'TALEExceptionReport.four_px', dm: '理货异常报表' }),
        path: '/inbound/tally/exceptionList',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    icon: 'wms-shangjia',
    children: [
      {
        name: $i18n.get({ id: 'ShelvingWorkList.four_px', dm: '上架作业单' }),
        path: '/inbound/puton/list',
      },

      {
        name: $i18n.get({ id: 'ShelvingJobDetails.four_px', dm: '上架作业明细' }),
        path: '/inbound/puton/detailList',
      },

      {
        name: $i18n.get({ id: 'ShelvingProcedure.four_px', dm: '上架操作步骤' }),
        path: '/inbound/puton/stepList',
      },

      {
        name: $i18n.get({ id: 'ShelvingExceptionReport.four_px', dm: '上架异常报表' }),
        path: '/inbound/puton/abnormalList',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'ReturnAndReceive.four_px', dm: '退件收货' }),
    icon: 'wms-tuijianshouhuo',
    children: [
      {
        name: $i18n.get({ id: 'WorkOrder.four_px', dm: '收货作业单' }),
        path: '/inbound/Returned/list',
      },

      {
        name: $i18n.get({ id: 'DeliveryDetails.four_px', dm: '收货作业明细' }),
        path: '/inbound/Returned/returnenFind',
      },

      {
        name: $i18n.get({ id: 'ReceiptOperationSteps.four_px', dm: '收货操作步骤' }),
        path: '/inbound/Returned/returnedStep',
      },

      {
        name: $i18n.get({ id: 'ReceiptExceptionReport.four_px', dm: '收货异常报表' }),
        path: '/inbound/Returned/returnedAbnor',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'ReturnUpperShelf.four_px', dm: '退件上架' }),
    icon: 'wms-tuijianshangjia',
    children: [
      {
        name: $i18n.get({ id: 'ShelvingWorkList.four_px', dm: '上架作业单' }),
        path: '/inbound/GrounDing/list',
      },

      {
        name: $i18n.get({ id: 'ShelvingJobDetails.four_px', dm: '上架作业明细' }),
        path: '/inbound/GrounDing/grounDingFind',
      },

      {
        name: $i18n.get({ id: 'ShelvingProcedure.four_px', dm: '上架操作步骤' }),
        path: '/inbound/GrounDing/grounDingStep',
      },

      {
        name: $i18n.get({ id: 'ShelvingExceptionReport.four_px', dm: '上架异常报表' }),
        path: '/inbound/GrounDing/grounDingAbnor',
      },
    ],
  },

  // {
  //   path: '/inbound/repush',
  //   name: $i18n.get({ id: 'SynchronousPush.four_px', dm: '入库同步推送' }),
  // },
];
// 出库
const outboundConifg: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'Chosen.four_px', dm: '拣选' }),
    icon: 'wms-jianxuan',
    children: [
      {
        name: $i18n.get({ id: 'HandmadeHuibo.four_px', dm: '手工汇波' }),
        path: '/outbound/pick/manualRemit/list',
      },

      {
        name: $i18n.get({ id: 'AutomaticHuibo.four_px', dm: '自动汇波' }),
        path: '/outbound/pick/central/data',
      },

      // {
      //   name: $i18n.get({ id: 'RetentionKanban.four_px', dm: '滞留看板' }),
      //   path: '/outbound/Tetention/list',
      // },

      // {
      //   name: '拣选作业单',
      //   path: '/outbound/pick/list',
      // },
      {
        name: $i18n.get({ id: 'PickingJobNo.four_px', dm: '拣选作业单号' }),
        path: '/outbound/pick/queue/list',
      },

      {
        name: $i18n.get({ id: 'PickingJobDetails.four_px', dm: '拣选作业明细' }),
        path: '/outbound/pick/detailList',
      },

      {
        name: $i18n.get({ id: 'PickingProcedure.four_px', dm: '拣选操作步骤' }),
        path: '/outbound/pick/stepList',
      },

      {
        name: $i18n.get({ id: 'PickingExceptionReport.four_px', dm: '拣选异常报表' }),
        path: '/outbound/pick/abnormalList',
      },
      {
        name: $i18n.get({ id: 'DeliveryOrderHuibo.four_px', dm: '出库单汇波' }),
        path: '/outbound/pick/manualRemitNew',
      },
      {
        name: $i18n.get({ id: 'RepickingManagementPage', dm: '复拣管理页面' }),
        path: '/outbound/pick/repickingManagementPage',
      },
    ],
  },

  // 集包
  {
    name: $i18n.get({ id: 'Package', dm: '集包' }),
    icon: 'wms-fenjian',
    children: [
      {
        name: $i18n.get({ id: 'PackageJobOrder.four_px', dm: '集包作业单' }),
        path: '/outbound/sorting/collect/list',
      },

      {
        name: $i18n.get({ id: 'PackageCollectionJobDetails.four_px', dm: '集包作业明细' }),
        path: '/outbound/sorting/collect/detailed',
      },
    ],
  },

  // 分拣一分
  {
    name: $i18n.get({ id: 'SortingOnePoint.four_px', dm: '分拣一分' }),
    icon: 'wms-fenjian',
    children: [
      {
        name: $i18n.get({ id: 'OnepointHomeworkOrder.four_px', dm: '一分作业单' }),
        path: '/outbound/one/sorting/list',
      },

      {
        name: $i18n.get({ id: 'OnepointOperationDetails.four_px', dm: '一分作业明细' }),
        path: '/outbound/one/sorting/detailed',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    icon: 'wms-fenjian',
    children: [
      {
        name: $i18n.get({ id: 'SortingJobList.four_px', dm: '分拣作业单' }),
        path: '/outbound/sort/list',
      },

      {
        name: $i18n.get({ id: 'FJZYMX.SortingJobDetails.four_px', dm: '分拣作业明细' }),
        path: '/outbound/sort/detailList',
      },

      {
        name: $i18n.get({ id: 'SortingProcedure.four_px', dm: '分拣操作步骤' }),
        path: '/outbound/sort/stepList',
      },

      {
        name: $i18n.get({ id: 'SortingExceptionReport.four_px', dm: '分拣异常报表' }),
        path: '/outbound/sort/abnormalList',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    icon: 'wms-dabao',
    children: [
      {
        name: $i18n.get({ id: 'PackedHomework.four_px', dm: '打包作业单' }),
        path: '/outbound/packbox/list',
      },

      {
        name: $i18n.get({ id: 'PackagingJobDetails.four_px', dm: '打包作业明细' }),
        path: '/outbound/packbox/packfind',
      },

      {
        name: $i18n.get({ id: 'PackagingJobStep.four_px', dm: '打包作业步骤' }),
        path: '/outbound/packbox/packstep',
      },

      {
        name: $i18n.get({ id: 'PackagingExceptionReport.four_px', dm: '打包异常报表' }),
        path: '/outbound/packbox/packabnor',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Delivery.four_px', dm: '发货' }),
    icon: 'wms-fahuo',
    children: [
      {
        name: $i18n.get({ id: 'DeliveryWorkOrder.four_px', dm: '发货作业单' }),
        path: '/outbound/deliver/list',
      },

      {
        name: $i18n.get({ id: 'ShippingDetails.four_px', dm: '发货作业明细' }),
        path: '/outbound/deliver/deliverfind',
      },

      {
        name: $i18n.get({ id: 'DeliveryJobStep.four_px', dm: '发货作业步骤' }),
        path: '/outbound/deliver/deliverStep',
      },

      {
        name: $i18n.get({ id: 'AnErrorOccurredWhileShipping.four_px', dm: '发货作业异常' }),
        path: '/outbound/deliver/deliverAbnor',
      },

      {
        name: $i18n.get({ id: 'PartialShipment', dm: '部分发货' }),
        path: '/outbound/partialshipment/list',
      },
    ],
  },
  {
    name: $i18n.get({ id: 'CodePlate', dm: '码板' }),
    icon: 'wms-fahuo',
    children: [
      {
        name: $i18n.get({ id: 'CodeBoardJobSheet', dm: '码板作业单' }),
        path: '/outbound/codeboard/list',
      },
      {
        name: $i18n.get({ id: 'CodeBoardOperationDetails', dm: '码板作业明细' }),
        path: '/outbound/codeboard/codeboardfind',
      },
      {
        name: $i18n.get({ id: 'CodePlateOperationSteps', dm: '码板操作步骤' }),
        path: '/outbound/codeboard/codeboardStep',
      },
    ],
  },
  {
    name: $i18n.get({ id: 'loadingCar.four_px', dm: '装车' }),
    icon: 'wms-jianxuan',
    children: [
      {
        name: $i18n.get({ id: 'LoadingOperationSheet', dm: '装车作业单' }),
        path: '/outbound/dispatchCar/list',
      },

      {
        name: $i18n.get({ id: 'DetailsOfLoadingOperation', dm: '装车作业明细' }),
        path: '/outbound/dispatchCar/dispatchCarFind',
      },

      {
        name: $i18n.get({ id: 'LoadingOperationSteps', dm: '装车作业步骤' }),
        path: '/outbound/dispatchCar/dispatchCarStep',
      },
    ],
  },
  {
    name: $i18n.get({ id: 'AuditbasedControl', dm: '稽查' }),
    icon: 'wms-jianxuan',
    children: [
      {
        name: $i18n.get({ id: 'CheckContainersAndOrders', dm: '稽查容器与订单' }),
        path: '/outbound/inspect/list',
      },
      {
        name: $i18n.get({ id: 'CheckOrdersAndGoods', dm: '稽查订单与商品' }),
        path: '/outbound/inspect/sku/list',
      },
    ],
  },

  // 包裹分拣
  {
    name: $i18n.get({ id: 'ParcelSorting', dm: '包裹分拣' }),
    icon: 'wms-fenjian',
    children: [
      {
        name: $i18n.get({ id: 'ParcelSortingJobSheet', dm: '包裹分拣作业单' }),
        path: '/outbound/parcelsort/list',
      },
      {
        name: $i18n.get({ id: 'ParcelSortingJobDetails', dm: '包裹分拣作业明细' }),
        path: '/outbound/parcelsort/parcelsortfind',
      },
    ],
  },
];

// 基础数据
const basedataConifg: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'BasicData.four_px', dm: '基础数据' }),
    path: '/basedata',
    icon: 'account',
    children: [
      {
        name: $i18n.get({ id: 'ContainerManagement.four_px', dm: '容器管理' }),
        path: '/basedata/containermanage',
      },
      {
        name: $i18n.get({ id: 'ServiceProviderOrderNumberRules', dm: '服务商单号规则' }),
        path: '/basedata/servicerule',
      },

      {
        name: $i18n.get({ id: 'ContainerTypeMaintenance.four_px', dm: '容器类型维护' }),
        path: '/basedata/containertype',
      },

      {
        name: $i18n.get({ id: 'SortingWallMaintenance.four_px', dm: '分拣墙维护' }),
        path: '/basedata/distributionwall',
      },

      {
        name: $i18n.get({ id: 'ConsoleMaintenance.four_px', dm: '操作台维护' }),
        path: '/basedata/operationfloor',
      },

      {
        name: $i18n.get({ id: 'HuiboChannelGroupManagement.four_px', dm: '汇波渠道组管理' }),
        path: '/basedata/channelgroup',
      },

      {
        name: $i18n.get({ id: 'TotalSingleChannelGroupManagement.four_px', dm: '总单渠道组管理' }),
        path: '/basedata/orderchannelgroup',
      },

      {
        name: $i18n.get({ id: 'LoadingChannelGroupManagement.four_px', dm: '装车渠道组管理' }),
        path: '/basedata/loadingchannelgroup',
      },

      {
        name: $i18n.get({ id: 'ReservoirAreaConfiguration.four_px', dm: '库区配置' }),
        path: '/basedata/locationconfig',
      },
      {
        name: $i18n.get({ id: 'LocationMixedConfiguration.four_px', dm: '库位混放配置' }),
        path: '/basedata/locationMixConfig',
      },
      {
        name: $i18n.get({ id: 'PackagingPhaseConfiguration.four_px', dm: '打包环节配置' }),
        path: '/basedata/outboundConfig',
      },
      {
        name: $i18n.get({ id: 'WholeLocationPickConfiguration', dm: '整库位拣选配置' }),
        path: '/basedata/PickByLocationConfig',
      },

      {
        name: $i18n.get({ id: 'CustomerGroupConfiguration.four_px', dm: '客户组配置' }),
        path: '/basedata/customerGroupConfig',
      },

      {
        name: $i18n.get({ id: 'WorkspaceConfiguration.four_px', dm: '工作区配置' }),
        path: '/basedata/workarea',
      },

      {
        name: $i18n.get({ id: 'PackagingMaterialMaintenance.four_px', dm: '包装材料维护' }),
        path: '/basedata/packingmaterial',
      },

      {
        name: $i18n.get({ id: 'AlgorithmSwitchConfiguration.four_px', dm: '算法开关配置' }),
        path: '/basedata/algorithmConfig',
      },

      {
        name: $i18n.get({ id: 'AgvTypeConfiguration.four_px', dm: 'AGV货型配置' }),
        path: '/basedata/basedataAgv',
      },

      {
        name: $i18n.get({ id: 'IdleTimeConfiguration.four_px', dm: '空闲时间配置' }),
        path: '/basedata/timeconfig',
      },

      {
        name: $i18n.get({ id: 'SystemAnnouncementAndHelp.four_px', dm: '系统公告与帮助' }),
        path: '/basedata/servicelist',
      },

      {
        name: $i18n.get({ id: 'AgentPrintConfiguration.four_px', dm: 'agent打印配置' }),
        path: '/basedata/agentadd',
      },

      {
        name: $i18n.get({ id: 'WaveStrategyConfiguration.four_px', dm: '波次策略配置' }),
        path: '/basedata/AigoSetting',
      },

      {
        name: $i18n.get({ id: 'InventoryMatchingStrategy.four_px', dm: '库存匹配策略' }),
        path: '/basedata/stockMatch',
      },

      {
        name: $i18n.get({ id: 'DingtalkPushConfiguration.four_px', dm: '钉钉推送配置' }),
        path: '/basedata/ddpushconfig',
      },

      {
        name: $i18n.get({ id: 'DeviceManagement.four_px', dm: '设备管理' }),
        path: '/basedata/device/manage',
      },

      {
        name: $i18n.get({ id: 'TotalAlertConfiguration.four_px', dm: '总单钉钉预警配置' }),
        path: '/basedata/totalorderconfig',
      },

      {
        name: $i18n.get({ id: 'ServiceProviderReturnPolicyConfiguration', dm: '服务商退件策略配置' }),
        path: '/basedata/returnPolicyConfig',
      },
      {
        name: $i18n.get({ id: 'ReplenishmentConfiguration', dm: '补货配置' }),
        path: '/basedata/replenish/pushconfig',
      },
      {
        name: $i18n.get({ id: 'TianmachineStrongControlNewProdu_40145819', dm: '天机强控新品管理' }),
        path: '/basedata/tjnewproductmanagement',
      },
      {
        name: $i18n.get({ id: 'PickingConfigurationByOrderShort', dm: '按单短拣配置' }),
        path: '/basedata/shortPickingConfig',
      },
      {
        name: $i18n.get({ id: 'ReturnReceiptConfiguration', dm: '退件收货配置' }),
        path: '/basedata/returnDeliveryConfig',
      },
      {
        name: $i18n.get({ id: 'OutofstockPasswordManagement', dm: '缺货密码管理' }),
        path: '/basedata/stockPasswordManage',
      },
      {
        name: $i18n.get({ id: 'DWSMeasurementSortingConfigurati_1013549046', dm: 'DWS测量分拣配置' }),
        path: '/basedata/MeasurementSortingConfigDWS',
      },
      {
        name: $i18n.get({ id: 'PackagingRequirementsConfigurati_338886589', dm: '打包要求配置' }),
        path: '/basedata/PackRequirements',
      },
      {
        name: $i18n.get({ id: 'GroupSingleRuleConfiguration.four_px', dm: '组单规则配置' }),
        path: '/basedata/groupOrderRuleConfig',
      },
      {
        name: $i18n.get({ id: 'EmergencyReplenishmentConfigurat_263464213', dm: '接单紧急补货配置' }),
        path: '/basedata/urgentReplenishConfig',
      },
      {
        name: $i18n.get({ id: 'PickTaskConfigurationManagement', dm: '拣选任务配置管理' }),
        path: '/basedata/pickTaskConfigs',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'LaborManagement.four_px', dm: '劳动力管理' }),
    path: '/basedata',
    icon: 'account',
    children: [
      {
        name: $i18n.get({ id: 'AccountAssignment.four_px', dm: '账号分配' }),
        path: '/basedata/accountlist',
      },

      {
        name: $i18n.get({ id: 'AttendanceManagement.four_px', dm: '考勤管理' }),
        path: '/basedata/attendanceManagement',
      },
    ],
  },
  {
    name: $i18n.get({ id: 'LinkManagement.four_px', dm: '链接管理' }),
    path: '/basedata',
    icon: 'account',
    children: [
      {
        name: $i18n.get({ id: 'LinkList', dm: '链接列表' }),
        path: '/basedata/systemswitch/config',
      },
    ],
  },
];

// 首页
const indexConifg: MenuConfigItem[] = [
  // {
  // name: '首页',
  // icon: 'chart-pie',
  // path: '/home',
  // children: [
  //   {
  //     name: '列表',
  //     path: '/ome',
  //   },
  // ],
  // },
];

// 库内
const insideConfig: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'Transit.four_px', dm: '移库' }),
    icon: 'wms-yiku',
    children: [
      {
        name: $i18n.get({ id: 'MigrationJob.four_px', dm: '移库作业单' }),
        path: '/inside/MoveKu/list',
      },

      {
        name: $i18n.get({ id: 'YKZYMX.MigrationJobDetails.four_px', dm: '移库作业明细' }),
        path: '/inside/MoveKu/movekuFind',
      },

      {
        name: $i18n.get({ id: 'TransitJobStep.four_px', dm: '移库作业步骤' }),
        path: '/inside/MoveKu/movekuStep',
      },

      {
        name: $i18n.get({ id: 'DatabaseMigrationExceptionList.four_px', dm: '移库异常列表' }),
        path: '/inside/MoveKu/movekuAbnor',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Replenishment.four_px', dm: '补货' }),
    icon: 'wms-buhuo',
    children: [
      // {
      //   name: $i18n.get({ id: 'ReplenishmentPolicyConfiguration.four_px', dm: '补货策略配置' }),
      //   path: '/inside/replenish/list',
      // },

      {
        name: $i18n.get({ id: 'ReplenishmentSkuQuery.four_px', dm: '补货SKU查询' }),
        path: '/inside/replenish/replesku',
      },

      // {
      //   name: $i18n.get({ id: 'ReplenishmentTurnoverBoxManagement.four_px', dm: '补货周转箱管理' }),
      //   path: '/inside/replenish/replezhoulist',
      // },

      {
        name: $i18n.get({ id: 'ReplenishmentWorkOrder.four_px', dm: '补货作业单' }),
        path: '/inside/replenish/repletask',
      },

      {
        name: $i18n.get({ id: 'ReplenishmentDetails.four_px', dm: '补货作业明细' }),
        path: '/inside/replenish/repleDetailed',
      },

      {
        name: $i18n.get({ id: 'ReplenishmentProcedure.four_px', dm: '补货操作步骤' }),
        path: '/inside/replenish/repleStep',
      },

      {
        name: $i18n.get({ id: 'ReplenishmentExceptionList.four_px', dm: '补货异常列表' }),
        path: '/inside/replenish/repleAbnor',
      },

      {
        name: $i18n.get({ id: 'ReplenishmentAbcQuery.four_px', dm: '补货ABC查询' }),
        path: '/inside/replenish/repleAbc',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Count.four_px', dm: '盘点' }),
    icon: 'wms-pandian',
    children: [
      {
        name: $i18n.get({ id: 'InventoryTasks.four_px', dm: '盘点作业列表' }),
        path: '/inside/Inventory/list',
      },

      {
        name: $i18n.get({ id: 'InventoryDetails.four_px', dm: '盘点作业明细' }),
        path: '/inside/Inventory/InventoryFind',
      },

      {
        name: $i18n.get({ id: 'InventoryOperationSteps.four_px', dm: '盘点操作步骤' }),
        path: '/inside/Inventory/InventoryStep',
      },

      {
        name: $i18n.get({ id: 'InventoryExceptionList.four_px', dm: '盘点异常列表' }),
        path: '/inside/Inventory/InvenToryChart',
      },
      {
        name: $i18n.get({ id: 'InventoryTaskList.four_px', dm: '盘点任务列表' }),
        path: '/inside/Inventory/InventoryGenTask',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'UnboxingLabelChanged.four_px', dm: '拆箱换标' }),
    icon: 'wms-dabao',
    children: [
      {
        name: $i18n.get({ id: 'UnpackingLabelChangedWorkOrder.four_px', dm: '拆箱换标作业单' }),
        path: '/inside/Devanning/list',
      },

      {
        name: $i18n.get({ id: 'UnboxingLabelChangedJobDetails.four_px', dm: '拆箱换标作业明细' }),
        path: '/inside/Devanning/detailList',
      },
    ],
  },

  // {
  //   name: 'ABC管理',
  //   icon: 'chart-pie',
  //   children: [
  //     {
  //       name: 'ACB分类策略配置',
  //       path: '/inside/abcadmin/list',
  //     },
  //     {
  //       name: 'SKU ABC查询',
  //       path: '/inside/abcadmin/abcadminSku',
  //     },
  //   ],
  // },
];

// 订单
const orderConifg: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'Order.four_px', dm: '订单' }),
    icon: 'wms-rukudingdan',
    children: [
      {
        name: $i18n.get({ id: 'InboundOrder.four_px', dm: '入库订单' }),
        path: '/order/inboundorder',
      },

      {
        name: $i18n.get({ id: 'CKDD.OutboundOrder.four_px', dm: '出库订单' }),
        path: '/order/outboundorder',
      },

      {
        name: $i18n.get({ id: 'ServiceProviderReturnOrder.four_px', dm: '服务商退件订单' }),
        path: '/order/bounceorder',
      },

      {
        name: $i18n.get({ id: 'FbaOrder.four_px', dm: 'FBA订单' }),
        path: '/order/fbaorder',
      },

      {
        name: $i18n.get({ id: 'ValueAddedServiceTicket.four_px', dm: '增值服务单' }),
        path: '/order/vasorder',
      },

      {
        name: $i18n.get({ id: 'LogisticsOrderNumberUpdate.four_px', dm: '物流单号更新' }),
        path: '/order/updateexpress',
      },

      {
        name: $i18n.get({ id: 'UpdateOrderCheckoutWeight', dm: '更新订单签出重' }),
        path: '/order/updateorderweight',
      },
      {
        name: $i18n.get({ id: 'TototListPrinting', dm: '打托清单打印' }),
        path: '/order/packingrepertoire',
      },
      {
        name: $i18n.get({ id: 'FastHandADD', dm: '订单测量查询' }),
        path: '/order/dwsMeasure',
      },
      {
        name: $i18n.get({ id: 'UpdateSNCode', dm: '更新SN码' }),
        path: '/order/updateSn',
      },
      {
        name: $i18n.get({ id: 'Update.Order.Notes.four_px', dm: '更新订单备注' }),
        path: '/order/updatewarehouseremark',
      },
    ],
  },
];

// AGV
const automationConfig: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'AgvOrderManagement.four_px', dm: 'AGV订单管理' }),
    icon: 'wms-AGVdingdanguanli',
    children: [
      {
        name: $i18n.get({ id: 'AgvReceivingAndShelvingOrder.four_px', dm: 'AGV收货上架订单' }),
        path: '/automation/automation/list',
      },

      {
        name: $i18n.get({ id: 'AgvPickingOffShelfOrder.four_px', dm: 'AGV拣货下架订单' }),
        path: '/automation/automation/AutoMationDown',
      },

      {
        name: $i18n.get({ id: 'AgvStorageAndShelvingOrder.four_px', dm: 'AGV移库上架订单' }),
        path: '/automation/automation/AutoMationUp',
      },

      {
        name: $i18n.get({ id: 'AgvStorageRemovalOrder.four_px', dm: 'AGV移库下架订单' }),
        path: '/automation/automation/AutoMationMoveDown',
      },

      {
        name: $i18n.get({ id: 'AgvTallyOrder.four_px', dm: 'AGV理货订单' }),
        path: '/automation/automation/tally',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'AgvDatabaseMigrationManagement.four_px', dm: 'AGV移库管理' }),
    icon: 'wms-AGVyikuguanli',
    children: [
      {
        name: $i18n.get({ id: 'StorageAndShelvingManagementOfAgv.four_px', dm: 'AGV移库上架管理' }),
        path: '/automation/automation/automationupmanage',
      },

      {
        name: $i18n.get({ id: 'MigrationAndRemovalOfAgv.four_px', dm: 'AGV移库下架管理' }),
        path: '/automation/automation/automationdownmanage',
      },

      {
        name: $i18n.get({ id: 'AGVReplenishmentSKUEnquiry', dm: 'AGV补货SKU查询' }),
        path: '/automation/automation/replesku',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'AgvInventoryManagement.four_px', dm: 'AGV库存管理' }),
    icon: 'wms-AGVkucunguanli',
    children: [
      {
        name: $i18n.get({ id: 'AgvInventoryReconciliation.four_px', dm: 'AGV库存对账' }),
        path: '/automation/automation/AutoMationReconc',
      },

      {
        name: $i18n.get({ id: 'AGV SKU GL.AgvSkuManagement.four_px', dm: 'AGV SKU 管理' }),
        path: '/automation/automation/AutoSkuManage',
      },

      {
        name: $i18n.get({ id: 'AGV KCYCD.AgvInventoryException.four_px', dm: 'AGV 库存异常单' }),
        path: '/automation/automation/abnormalstock',
      },

      {
        name: $i18n.get({ id: 'AGV KCTZD.AgvInventoryAdjustmentOrder.four_px', dm: 'AGV 库存调整单' }),
        path: '/automation/automation/autostockajust',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'AMROrderManagement.four_px', dm: 'AMR订单管理' }),
    icon: 'wms-AGVkucunguanli',
    children: [
      {
        name: $i18n.get({ id: 'AMRPicksOffshelfOrders.four_px', dm: 'AMR拣选下架订单' }),
        path: '/automation/packingOffShelf/list',
      },
    ],
  },
];

// 商品管理
const goodsConfig = [
  {
    name: $i18n.get({ id: 'CommodityManagement.four_px', dm: '商品管理' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'SkuInformation.four_px', dm: 'sku信息' }),
        path: '/goods/message/stockmessage',
      },
      {
        name: $i18n.get({ id: 'SkuCheck.four_px', dm: 'SKU查验' }),
        path: '/goods/message/skucheckreview',
      },
      {
        name: $i18n.get({ id: 'SKUTrayGaugeBoxGauge', dm: 'SKU托规箱规' }),
        path: '/goods/message/skuPalletSpec',
      },
      {
        name: $i18n.get({ id: 'SKUPinGrade', dm: 'SKU动销等级' }),
        path: '/goods/message/SkuDynamicSalesLevel',
      },
      {
        name: $i18n.get({ id: 'InventoryQuery.four_px', dm: '库存查询' }),
        path: '/goods/message/stockquery',
      },

      {
        name: $i18n.get({ id: 'InventoryFlow.four_px', dm: '库存流水' }),
        path: '/goods/message/stockwater',
      },

      {
        name: $i18n.get({ id: 'InventoryException.four_px', dm: '库存异常' }),
        path: '/goods/message/stockAbnor',
      },

      {
        name: $i18n.get({ id: 'DifferentialLocationManagement.four_px', dm: '差异库位管理' }),
        path: '/goods/message/stockdiff',
      },

      {
        name: $i18n.get({ id: 'AbnormalLocationInventoryManagem', dm: '异常库位库存管理' }),
        path: '/goods/message/abnormalLocationInventory',
      },

      {
        name: $i18n.get({ id: 'InventoryAdjustmentRecords.four_px', dm: '库存调整记录' }),
        path: '/goods/message/stockRecord',
      },
      {
        name: $i18n.get({ id: 'InventoryManagement', dm: '库存多货管理' }),
        path: '/goods/message/mutilpleInventory',
      },
      {
        name: $i18n.get({ id: 'InventoryMulticargoFlow', dm: '库存多货流水' }),
        path: '/goods/message/mutilpleInventoryFlow',
      },
      {
        name: $i18n.get({ id: 'VarianceDocManagement', dm: '差异单管理' }),
        path: '/goods/message/invdifferentJob',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'MerchantPackingMaterialManagemen_328030451', dm: '商家包材管理' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'PackagingMaterialMaintenance.four_px', dm: '包装材料维护' }),
        path: '/goods/packageInfo/packageInfoMaintain',
      },
      {
        name: $i18n.get({ id: 'PackingMaterialInventoryManageme_1696663575', dm: '包材库存管理' }),
        path: '/goods/packageInfo/invPackageInfoManager',
      },
      {
        name: $i18n.get({ id: 'PackingMaterialInventoryFlow', dm: '包材库存流水' }),
        path: '/goods/packageInfo/invPackageInfoHistory',
      },
      {
        name: $i18n.get({ id: 'PackingMaterialInventoryCount', dm: '包材库存盘点' }),
        path: '/goods/packageInfo/invPackageInfoTakeStock',
      },
      {
        name: $i18n.get({ id: 'PackingMaterialAbnormalInventory', dm: '包材异常库存' }),
        path: '/goods/packageInfo/invPackageInfoHistoryException',
      },
      {
        name: $i18n.get({ id: 'PackingMaterialUsageException.four_px', dm: '包材使用异常' }),
        path: '/goods/packageInfo/packageUseException',
      },
      {
        name: $i18n.get({ id: 'packageUseExceptionDetail.four_px', dm: '包材使用异常' }),
        path: '/goods/packageInfo/packageUseExceptionDetail',
      },
    ],
  },
  {
    name: $i18n.get({ id: 'CainiaoMerchantPackingMaterialMa_520521191', dm: '菜鸟商家包材管理' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'PackingMaterialWarehousing', dm: '包材入库' }),
        path: '/goods/cainiaoPackage/purchaseOrder',
      },
      {
        name: $i18n.get({ id: 'PackingMaterialAllocation', dm: '包材调拨' }),
        path: '/goods/cainiaoPackage/inventoryRequisition',
      },
      {
        name: $i18n.get({ id: 'RefundManagement', dm: '退供管理' }),
        path: '/goods/cainiaoPackage/inventoryRefund',
      },
      {
        name: $i18n.get({ id: 'InventoryBalance.QMybi', dm: '库存余额' }),
        path: '/goods/cainiaoPackage/inventoryBalances',
      },
      {
        name: $i18n.get({ id: 'InLibraryCounting', dm: '库内盘点' }),
        path: '/goods/cainiaoPackage/inventoryStock',
      },
    ],
  },
];

// 系统公告 报表
const serviceConfig = [
  {
    name: $i18n.get({ id: 'Report.four_px', dm: '报表' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'OutboundKanban.four_px', dm: '出库看板' }),
        path: '/service/outbound/billboard',
      },

      {
        name: $i18n.get({ id: 'StorageKanban.four_px', dm: '入库看板' }),
        path: '/service/inbound/billboard',
      },

      {
        name: $i18n.get({ id: 'RetentionKanban.four_px', dm: '滞留看板' }),
        path: '/service/Tetention/list',
      },
      {
        name: $i18n.get({ id: 'ReceiptTimeoutKanban', dm: '入库超时看板' }),
        path: '/service/inboundata/list',
      },
      {
        path: '/service/rowexportlist',
        name: $i18n.get({ id: 'ExportList', dm: '导出列表' }),
      },

      {
        name: $i18n.get({ id: 'FigurePortrait.four_px', dm: '人物画像' }),
        path: '/service/PeoplePortraits',
      },

      {
        name: $i18n.get({ id: 'DistributionOfPersonnelOperation.four_px', dm: '人员作业分布' }),
        path: '/service/personnel/operation',
      },

      {
        name: $i18n.get({ id: 'AeBigPromotionDataMonitoringScreen.four_px', dm: 'AE大促数据监控大屏' }),
        path: '/service/AE',
      },
      {
        path: '/service/fbireport',
        name: $i18n.get({ id: 'ReturnServiceBoard', dm: '退件服务看板' }),
      },
      {
        path: '/service/fbivaluereport',
        name: $i18n.get({ id: 'ValueaddedServiceKanban', dm: '增值服务看板' }),
      },
      {
        path: '/service/workmonitor',
        name: $i18n.get({ id: 'OperationMonitoringBoard', dm: '作业监控看板' }),
      },
      {
        path: '/service/measurementboard',
        name: $i18n.get({ id: 'MeasuringSortingKanban', dm: '测量分拣看板' }),
      },
      {
        path: '/service/CapacityHourBoard',
        name: $i18n.get({ id: 'CapacityHourBoard', dm: '产能小时看板' }),
      },
    ],
  },

  {
    name: $i18n.get({ id: 'DigitalWarehouse.four_px', dm: '数字仓库' }),
    icon: 'wms-AGVkucunguanli',
    children: [
      {
        name: $i18n.get({ id: 'PackageVideoQuery.four_px', dm: '打包视频查询' }),
        path: '/service/VideoInquiry',
      },
      {
        name: $i18n.get({ id: 'CommodityStorageVisualization.four_px', dm: '商品储存可视化' }),
        path: '/service/addresscore',
      },

      {
        name: $i18n.get({ id: 'StorageVisualization.four_px', dm: '库容可视化' }),
        path: '/service/hotmap',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'VisualizationOfTheCenter.four_px', dm: '中枢可视化' }),
    icon: 'wms-AGVkucunguanli',
    children: [
      {
        name: $i18n.get({ id: 'AlgorithmRemittance.four_px', dm: '算法汇单' }),
        path: '/service/algorithm/list',
      },
    ],
  },
];

// 分拨
const allocateConfig: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'DistributionOrder.four_px', dm: '分拨订单' }),
    icon: 'wms-jianxuan',
    children: [
      {
        name: $i18n.get({ id: 'PackageOrder.four_px', dm: '包裹订单' }),
        path: '/allocate/parcelOrder/list',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'SortingJobList.four_px', dm: '分拣作业单' }),
        path: '/allocate/assort/queue/list',
      },

      {
        name: $i18n.get({ id: 'FJZYMX.SortingJobDetails.four_px', dm: '分拣作业明细' }),
        path: '/allocate/assort/detailList',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'GroupPackage.four_px', dm: '组包' }),
    icon: 'wms-dabao',
    children: [
      {
        name: $i18n.get({ id: 'GroupPackageWorkList.four_px', dm: '组包作业单' }),
        path: '/allocate/group/queue/list',
      },

      {
        name: $i18n.get({ id: 'GroupPackageJobDetails.four_px', dm: '组包作业明细' }),
        path: '/allocate/group/detailList',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Shipment.four_px', dm: '发运' }),
    icon: 'wms-fahuo',
    children: [
      {
        name: $i18n.get({ id: 'ShippingJobOrder.four_px', dm: '发运作业单' }),
        path: '/allocate/delivery/queue/list',
      },

      {
        name: $i18n.get({ id: 'ShippingJobDetails.four_px', dm: '发运作业明细' }),
        path: '/allocate/delivery/detailList',
      },

      {
        name: $i18n.get({ id: 'ShippingOperationException.four_px', dm: '发运作业异常' }),
        path: '/allocate/delivery/deliveryAbnor',
      },
    ],
  },
];

// FBA
const fbaConfig: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'FbaDeliveryOrder.four_px', dm: 'FBA送仓委托单' }),
    icon: 'wms-rukudingdan',
    path: '/fba/consignment/list',
  },

  {
    name: $i18n.get({ id: 'FbaDelivery.four_px', dm: 'FBA发货' }),
    icon: 'wms-tuijiandingdan',
    children: [
      {
        name: $i18n.get({ id: 'FbaShippingOrder.four_px', dm: 'FBA发货作业单' }),
        path: '/fba/deliver/list',
      },

      {
        name: $i18n.get({ id: 'FbaShipmentExceptionReport.four_px', dm: 'FBA发货异常报表' }),
        path: '/fba/deliver/abnormal',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'Punch.four_px', dm: '打托' }),
    icon: 'wms-tuijiandingdan',
    children: [
      {
        name: $i18n.get({ id: 'PalletOrder.four_px', dm: '打托作业单' }),
        path: '/fba/pallet/list',
      },

      {
        name: $i18n.get({ id: 'ReportToBeMeasured.four_px', dm: '待测量报表' }),
        path: '/fba/pallet/report',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'FBAWarehousing.four_px', dm: 'FBA入库' }),
    icon: 'wms-tuijiandingdan',
    children: [
      {
        name: $i18n.get({ id: 'InboundWorkOrder.four_px', dm: '入库作业单' }),
        path: '/fba/inbound/list',
      },

      {
        name: $i18n.get({ id: 'InboundExceptionReport.four_px', dm: '入库异常报表' }),
        path: '/fba/inbound/exception',
      },
    ],
  },
];

const devConfig = [
  {
    name: $i18n.get({ id: 'Surveillance.four_px', dm: '监控' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'OutboundMonitoringBi.four_px', dm: '出库监控bi' }),
        path: '/dev/monitor/outbound',
      },

      {
        name: $i18n.get({ id: 'InventoryMonitoring.four_px', dm: '库存监控' }),
        path: '/dev/monitor/stock',
      },
    ],
  },

  {
    name: $i18n.get({ id: '31255241957707776.CNTM', dm: '入库' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'RepushInStorage', dm: '入库重推' }),
        path: '/dev/inbound/repush',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'MoveWarehouse', dm: '搬仓' }),
    icon: 'wms-shangpinguanli',
    children: [
      {
        name: $i18n.get({ id: 'BatchTransfer', dm: '批量移库' }),
        path: '/dev/move/location',
      },
    ],
  },
];

// 退件
const returnServiceConfig: MenuConfigItem[] = [
  {
    name: $i18n.get({ id: 'ReturnAndReceive.four_px', dm: '退件收货' }),
    icon: 'wms-tuijianshangjia',
    children: [
      {
        name: $i18n.get({ id: 'WorkOrder.four_px', dm: '收货作业单' }),
        path: '/returnService/receive/receiveList',
      },

      {
        name: $i18n.get({ id: 'DetailsOfReceivingWorkOrders.four_px', dm: '收货作业单明细' }),
        path: '/returnService/receive/detailList',
      },

      {
        name: $i18n.get({ id: 'ProcedureOfReceivingGoods.four_px', dm: '收货作业步骤' }),
        path: '/returnService/receive/stepList',
      },

      {
        name: $i18n.get({ id: 'ReceiptExceptionReport.four_px', dm: '收货异常报表' }),
        path: '/returnService/receive/abortList',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'CheckTheQualityOfReturnedParts.four_px', dm: '退件质检清点' }),
    icon: 'wms-tuijianshangjia',
    children: [
      {
        name: $i18n.get({ id: 'InspectionAndInventoryWorkSheet.four_px', dm: '质检清点作业单' }),
        path: '/returnService/ReturnCheck/plantList',
      },

      {
        name: $i18n.get({ id: 'InspectionAndInventoryWorkListDetails.four_px', dm: '质检清点作业单明细' }),
        path: '/returnService/ReturnCheck/detailList',
      },

      {
        name: $i18n.get({ id: 'InspectionAndInventoryProcedures.four_px', dm: '质检清点作业步骤' }),
        path: '/returnService/ReturnCheck/stepList',
      },

      {
        name: $i18n.get({ id: 'InspectionExceptionReport.four_px', dm: '清点质检异常报表' }),
        path: '/returnService/ReturnCheck/abortList',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'TJDD.ReturnOrder.four_px', dm: '退件订单' }),
    icon: 'wms-tuijianshangjia',
    children: [
      {
        name: $i18n.get({ id: 'ReturnAndWarehousingList.four_px', dm: '退件入库单' }),
        path: '/returnService/ReturnOrder/list',
      },

      {
        name: $i18n.get({ id: 'ReturnExceptionHandling.four_px', dm: '退件异常处理' }),
        path: '/returnService/exception/list',
      },
      {
        name: $i18n.get({ id: 'StagingList', dm: '暂存列表' }),
        path: '/returnService/returnstorage/list',
      },
    ],
  },

  {
    name: $i18n.get({ id: 'ReturnSKUManagement', dm: '退件SKU管理' }),
    icon: 'wms-tuijianshangjia',
    children: [
      {
        name: $i18n.get({ id: 'ReturnSKUManagement', dm: '退件SKU管理' }),
        path: '/returnService/sku/list',
      },
    ],
  },
];

const asideMenuConfig: MenuConfig = {
  index: indexConifg,
  inbound: inboundConifg,
  outbound: outboundConifg,
  basedata: basedataConifg,
  inside: insideConfig,
  automation: automationConfig,
  returnService: returnServiceConfig,
  goods: goodsConfig,
  order: orderConifg,
  service: serviceConfig,
  allocate: allocateConfig,
  fba: fbaConfig,
  dev: devConfig,
};

export { headerMenuConfig, asideMenuConfig };
